var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5470_47442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8938 7.21875C23.3855 4.59375 19.6145 4.59375 18.1062 7.21875L4.53087 30.8438C3.02251 33.4688 4.90796 36.75 7.9247 36.75H35.0753C38.092 36.75 39.9775 33.4687 38.4691 30.8438L24.8938 7.21875ZM20.2273 26.9614C19.8071 26.9614 19.4617 26.6285 19.4442 26.2068L18.961 14.5793C18.9424 14.1319 19.2984 13.759 19.7441 13.759H23.1846C23.6303 13.759 23.9863 14.1319 23.9677 14.5793L23.4845 26.2068C23.467 26.6285 23.1216 26.9614 22.7014 26.9614H20.2273ZM21.5329 28.8908C23.1788 28.8908 24.3036 30.0209 24.3036 31.4817C24.3036 32.8874 23.1788 34.0174 21.5329 34.0174C19.8596 34.0174 18.7349 32.8874 18.7349 31.4817C18.7349 30.0209 19.8596 28.8908 21.5329 28.8908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5470_47442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warning-filled.45e7c06539737f0203396e27ab77b734.svg";
export { ForwardRef as ReactComponent };